<template>
  <header class="app-header">
    <router-link
      to="/dashboard"
      class="app-header-brand"
    >
      <span class="brand-focus">Focus</span><span class="brand-flow">Flow</span>
    </router-link>
    <div class="app-header-actions">
      <FocusTimer />
      <span class="app-header-divider" />
      <AlertsBell />
      <UserMenu />
    </div>
  </header>
</template>

<script setup lang="ts">
import FocusTimer from "./FocusTimer.vue"
import AlertsBell from "./AlertsBell.vue"
import UserMenu from "./UserMenu.vue"
</script>

<style scoped>
.app-header-brand {
  font-size: 1.25rem;
  color: var(--color-primary);
  text-decoration: none;
  letter-spacing: -0.01em;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 0;
}

.brand-focus {
  font-family: 'Manrope', sans-serif;
  font-weight: 800;
}
.brand-flow {
  color: var(--color-on-surface-variant);
}

.app-header-actions {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
  flex-shrink: 1;
}

/* Subtle vertical separator between the focus timer cluster and the
   notifications/user actions. Uses the surface-variant token so it
   stays a tonal hint, not a border line. */
.app-header-divider {
  width: 1px;
  height: 1.25rem;
  background-color: var(--color-outline-variant);
  opacity: 0.5;
  margin: 0 0.125rem;
  flex-shrink: 0;
}

/* Narrow phones: tighten gaps and drop the divider so the action row
   never overflows. Anything that doesn't fit (timer text) collapses
   inside FocusTimer's own breakpoints. */
@media (max-width: 380px) {
  .app-header-actions {
    gap: 0.25rem;
  }
  .app-header-divider {
    display: none;
  }
}

/* Very narrow (<= 340px): trim the brand to the wordmark mark only
   so the action cluster keeps its full functionality. */
@media (max-width: 340px) {
  .app-header-brand {
    font-size: 1.125rem;
  }
  .brand-flow {
    display: none;
  }
}
</style>
